// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__15_nk","inner":"Form_inner__d_MeA","range":"Form_range__1OQxW","name":"Form_name__gswXl","actions":"Form_actions__3_Azr"};